export const gql = String.raw
